import swal from 'sweetalert2'

const VueSwal = {}

VueSwal.install = (Vue) => {
  Vue.prototype.$swal = swal
}

export default VueSwal



// WEBPACK FOOTER //
// ./src/utilities/vue-sweetalert2.js